import {RUM} from './rum/interface'
import {sensitiveDataCleanerMiddleware} from './middlewares/sensitiveDataCleanerMiddleware'
import pWaterfall from 'p-waterfall'
import {withNamespace} from './shared/withNamespace'

/**
 * Ссылка куда будут попадать логи:\
 * https://error.yandex-team.ru/projects/eats-restapp
 *
 * Чтобы включить вывод в консоль, надо открыть страницу с параметром `_rum_debug=1` или `_rum_debug=2`\
 * Например: https://vendor.yandex.ru/home?_rum_debug=1, для отключения `_rum_debug=0`
 */
export const errorLogger = withNamespace(
  createLogger(),
  (namespace, log) => [{...log, message: [namespace, log.message].filter(Boolean).join(':')}] as const
)

function createLogger() {
  return (log: ErrorLog) =>
    pWaterfall(
      [
        sensitiveDataCleanerMiddleware<ErrorLog>,
        (prev) => {
          RUM.logError({
            error: prev.error,
            level: prev.level || 'error',
            type: prev.sourceType,
            message: prev.message,
            additional: prev.additional || {}
          })
        }
      ],
      log
    ).catch(onError)
}

function onError(error: unknown) {
  const safeError = error instanceof Error ? error : new Error(`NonError: ${error}`)
  RUM.logError({
    error: safeError,
    level: 'error',
    message: 'ErrorLogger',
    additional: {}
  })
  console.error(error)
}

type ErrorLog = {
  error: string | Error | ErrorEvent
  level?: 'error' | 'critical' | 'warn'
  sourceType?: string
  additional?: Record<string, unknown>
  message?: string
}
